import React from "react";
import { useNavigate } from "react-router-dom";
import Logo from "../components/Logo";

const WA_LINK = "https://wa.me/918650373635";

export default function Contact() {
  const navigate = useNavigate();
  return (
    <div style={s.wrapper}>
      <header style={s.header}>
        <div onClick={() => navigate("/app/")} style={{ cursor: "pointer" }}>
          <Logo size={28} showText={true} />
        </div>
      </header>
      <main style={s.main}>
        <h1 style={s.h1}>Contact Us</h1>
        <p style={s.sub}>Have a question? We're happy to help.</p>

        <div style={s.cards}>
          <a href={WA_LINK} target="_blank" rel="noreferrer" style={s.card}>
            <div style={s.cardIcon}>📱</div>
            <div style={s.cardTitle}>WhatsApp</div>
            <div style={s.cardDesc}>Chat with us directly on WhatsApp for the fastest response.</div>
            <div style={s.cardCta}>Open WhatsApp →</div>
          </a>

          <a href="mailto:support@botsaathi.com" style={s.card}>
            <div style={s.cardIcon}>📧</div>
            <div style={s.cardTitle}>Email</div>
            <div style={s.cardDesc}>Send us an email and we'll respond within 1 business day.</div>
            <div style={s.cardCta}>support@botsaathi.com</div>
          </a>

          <div style={s.card}>
            <div style={s.cardIcon}>📍</div>
            <div style={s.cardTitle}>Location</div>
            <div style={s.cardDesc}>Ramnagar, Uttarakhand, India — 244715</div>
            <div style={s.cardCta}>India 🇮🇳</div>
          </div>
        </div>

        <div style={s.hours}>
          <div style={s.hoursTitle}>Business Hours</div>
          <div style={s.hoursText}>Monday – Saturday: 9:00 AM – 7:00 PM IST</div>
          <div style={s.hoursText}>Sunday: Closed (Bot is still active 24/7 😄)</div>
        </div>
      </main>
      <footer style={s.footer}>
        <span style={{ color: "#444" }}>© 2025 BotSaathi. All rights reserved.</span>
        <a href="/privacy-policy" style={s.footerLink}>Privacy Policy</a>
        <a href="/terms-of-service" style={s.footerLink}>Terms of Service</a>
        <a href="/refund-policy" style={s.footerLink}>Refund Policy</a>
      </footer>
    </div>
  );
}

const s = {
  wrapper: { background: "#0a0a0a", minHeight: "100vh", color: "#d0d0d0" },
  header: { padding: "20px 40px", borderBottom: "1px solid #1a1a1a" },
  main: { maxWidth: 860, margin: "0 auto", padding: "60px 24px" },
  h1: { fontSize: 36, fontWeight: 700, color: "#fff", marginBottom: 10, fontFamily: "Georgia, serif" },
  sub: { fontSize: 16, color: "#666", marginBottom: 48 },
  cards: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: 20, marginBottom: 48 },
  card: { background: "#111", border: "1px solid #1e1e1e", borderRadius: 14, padding: 28, textDecoration: "none", display: "flex", flexDirection: "column", gap: 8, transition: "border-color 0.2s", cursor: "pointer" },
  cardIcon: { fontSize: 32, marginBottom: 4 },
  cardTitle: { fontSize: 16, fontWeight: 700, color: "#fff" },
  cardDesc: { fontSize: 14, color: "#666", lineHeight: 1.7, flex: 1 },
  cardCta: { fontSize: 13, color: "#25d366", marginTop: 4 },
  hours: { background: "#111", border: "1px solid #1e1e1e", borderRadius: 14, padding: 28 },
  hoursTitle: { fontSize: 16, fontWeight: 700, color: "#fff", marginBottom: 12 },
  hoursText: { fontSize: 14, color: "#666", lineHeight: 1.8 },
  footer: { borderTop: "1px solid #1a1a1a", padding: "24px 40px", display: "flex", gap: 20, alignItems: "center", justifyContent: "center", flexWrap: "wrap" },
  footerLink: { fontSize: 13, color: "#555", textDecoration: "none" },
};
